import {bufferTime, catchError, filter, map, mergeMap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  addBidContacts,
  API_GET_BID_CONTACTS,
  API_GET_BID_CONTACTS_DONE,
  getBidContactsDone
} from "../actions/bidcontacts";
import * as R from 'ramda';
import {getBidInvites$} from "../services/bids";
import {catchErrorsandResume, MODEL_INSERTION_BUFFER_INTERVAL_MS} from "./index";

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_BID_CONTACTS),
  mergeMap(action => getBidInvites$({ bidId: action.payload.bidId, offset: action.payload.offset }).pipe(
    map(({response}) => getBidContactsDone(response)),
    catchError(error => of(networkError({...error, number: '10073-'+error.status})))
  )),
  catchErrorsandResume(20001)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_BID_CONTACTS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => addBidContacts(results)),
  catchErrorsandResume(20002)
);

export const bidContactsEpic = combineEpics(
  getMultipleEpic,
  processMultipleEpic
);




// WEBPACK FOOTER //
// ./src/network/bidcontacts.js